import styled from 'styled-components';
import { body2, borderRadius, colors, spacing, subtitle2, subtleShadow } from 'ui/theme';
import { pxToRem } from 'utils/convert';

// NoUngrouped
export const NoUngroupedQuickRepliesContainer = styled.div`
display: flex;
padding: ${spacing.plusHalf}; 
flex-direction: column;
gap: ${spacing.half};
align-self: stretch;
align-items: center;

border-radius: ${borderRadius.xxl};
background: ${colors.backgroundSecondary};
`;
export const NoUngroupedQuickRepliesText = styled.div`
color: ${colors.textSecondary};
text-align: center;
`;

// UngroupedQuickReplies
export const UngroupedQuickRepliesContainer = styled.div`
display: flex;
flex-direction: column;
gap: ${spacing.base};
`;

export const QuickReplyHeaderContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
`;

export const QuickReplyHeader = styled.div`
display: flex;
justify-content: space-between;
align-items: flex-start;
align-self: stretch;
`;

export const QuickReplyHeaderText = styled.div`
    ${subtitle2}
    color: ${colors.textPrimary};
`;

export const QuickReplyDescription = styled.div`
align-self: stretch;
${body2}
color: ${colors.textSecondary};
`;

export const QuickReplyHeaderActions = styled.div``;

export const QuickRepliesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  align-self: stretch;
`;

export const QuickReplyRow = styled.div`
    display: flex;
    align-items: center;
    gap: ${spacing.threeQuarter};
    align-self: stretch;
`;

export const QuickReply = styled.div`
    display: flex;
    padding: ${spacing.half} ${spacing.threeQuarter};
    justify-content: flex-start;
    align-items: center;
    align-self: stretch;
    width: 100%;
    height: ${pxToRem(40)};
    gap: ${spacing.half};

    border-radius: ${borderRadius.md};
    border: 1px solid ${colors.borderPrimary};
    background: ${colors.backgroundPrimary};
    /* shadows/subtleShadow */
    ${subtleShadow}
`;
